<footer class="footer container w-100 bg-white border-top py-4">
  <div
    class="col-12 d-flex justify-content-between align-items-start align-items-lg-center flex-wrap flex-column flex-lg-row"
  >
    <div
      class="d-flex align-items-start align-items-lg-center flex-wrap py-2 flex-column flex-lg-row"
    >
      <img
        src="../../../../assets/images/logo.svg"
        alt="logo"
        class="footer--logo mr-4"
      />
      <a
        class="footer--contact-link mr-4 cursor-pointer"
        (click)="navigateToTermsAndConditions()"
        >წესები & პირობები</a
      >
      <a
        class="footer--contact-link"
        href="https://www.tbcbankgroup.com/esg/our-environmental-policy/"
        target="_blank"
        >გარემოსდაცვითი პოლიტიკა</a
      >
    </div>
    <div
      class="d-flex align-items-start align-items-lg-center py-2 flex-column flex-lg-row"
    >
      <!-- TOP.GE ASYNC COUNTER CODE -->
      <!-- <div id="top-ge-counter-container" data-site-id="117453"></div> -->

      <!-- / END OF TOP.GE COUNTER CODE -->
      <span class="mr-4">
        <img
          src="../../../../assets/images/phone.svg"
          alt="phone"
          class="mr-2"
        />
        032 215 86 86
      </span>
      <div class="footer--social-links">
        <a
          class="mr-2"
          href="https://www.facebook.com/www.livo.ge/"
          target="_blank"
        >
          <img
            src="../../../../assets/images/facebook.svg"
            alt="facebook"
            class="mr-2"
          />
        </a>
        <a
          class="mr-2"
          href="https://www.youtube.com/channel/UCUVJ7padp-2fYfxRHDYUN9w"
          target="_blank"
        >
          <img
            src="../../../../assets/images/youtube.svg"
            alt="youtube"
            class="mr-2"
          />
        </a>
        <a href="https://www.instagram.com/livo_ge/" target="_blank">
          <img
            src="../../../../assets/images/instagram.svg"
            alt="instagram"
            class="mr-2"
          />
        </a>
      </div>
    </div>
  </div>
</footer>
